const mutations = {

  clearRegisterFieldErrors (state) {
    state.errorRegisterFields = []
  },
  setValidationErrorFields (state, errorFields) {
    state.errorRegisterFields = errorFields
  },
  previousStep (state) {
    state.currentStep--
  },
  nextStep (state) {
    state.currentStep++
  },
  createOrder (state) {
    state.isLoading = true
  },
  createOrderSuccess (state) {
    state.isLoading = false
    state.isComplete = true
  },
  createOrderError (state) {
    state.isLoading = false
  },
  clearState (state) {
    state.currentStep = 1
    state.registerFields = {
      customerName: '',
      streetName: '',
      houseNumber: '',
      houseNumberAdd: '',
      zipCode: '',
      city: '',
      email: '',
      phoneNumber: '',
      chamberOfCommerceNumber: '',
      vatNumber: '',
      contactFirstName: '',
      contactMiddleName: '',
      contactLastName: '',
      contactFunction: '',
      contactEmail: '',
      contactPhoneNumber: '',
    }
    state.errorRegisterFields = []
    state.isLoading = false
    state.isComplete = false
  },
}

export default mutations
